import { helpers } from '../helpers.js';

var accomodationPeriodType = {
  options: {
    // global options
  },

  selectors: {
    select: ".js-accomodation-period-type-select",
		type0: ".js-accomodation-period-type-0",
		type1: ".js-accomodation-period-type-1",
  },

  init: function () {
    const self = this;

    self.bindEvents();
    self.handleSelectChange(); // Initialize on load
  },

  bindEvents: function () {
    const self = this;

    const selectElement = jQuery(self.selectors.select);

    if (selectElement.length > 0) {
      selectElement.on('change', function() {
        self.handleSelectChange();
      });
    }
  },

  handleSelectChange: function () {
    const self = this;
    const selectElement = jQuery(self.selectors.select);
    
    if (selectElement.length === 0) return;

    const selectedValue = selectElement.val();
    
    // Hide all types first
    self.hideAllTypes();
    
    // Show the selected type
    self.showType(selectedValue);
  },

  hideAllTypes: function () {
    const self = this;
    
    // Hide all type elements
    jQuery(self.selectors.type0).addClass('d-none');
    jQuery(self.selectors.type1).addClass('d-none');
  },

  showType: function (value) {
    const self = this;
    
    // Show the appropriate type based on value
    if (value === '0') {
      jQuery(self.selectors.type0).removeClass('d-none');
    } else if (value === '1') {
      jQuery(self.selectors.type1).removeClass('d-none');
    }
  }
}

// Export
export { accomodationPeriodType };